import { render, staticRenderFns } from "./ReasonForm.vue?vue&type=template&id=14af25e2"
import script from "./ReasonForm.vue?vue&type=script&lang=js"
export * from "./ReasonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports